import React, { useEffect, useState, Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { capitalize, isEmpty, startCase, camelCase } from 'lodash';
import swal from 'sweetalert';
import AppLoader from '../../../components/loaders/AppLoader';
import { showModal } from '../../../redux/error/ErrorAction';
import { hideLoading, showLoading } from '../../../redux/loader/LoaderActions';
import { GET, POST, DELETE } from '../../../services/rest.service';
import Chat from '../../../components/UI/Chat';
import docImage from '../../../../assets/img/doc.png';
import {
  accessGeneralOrCargoType,
  getJobServices,
  weightFormat,
  getJobStatus,
  getPortName,
} from '../../../helpers/utils';
import { LeftArrowSvg } from '../../../components/UI/CommanUI';
import { showDocumentModal } from '../../../redux/user/UserActions';
import { useChat } from '../../../helpers/customHooks';
import DisputeModal from '../../../components/Modals/DisputeModal';

const RejectedJobDetails = (props) => {
  const [jobDetails, setDetails] = useState({});
  const dispatch = useDispatch();
  const params = new URLSearchParams(props.location.search).get('id');
  const job_id = params;
  const serviceData = useSelector((state) => state.enumData);
  const [chatbox, setChatbox] = useState(false);
  const [chatlist, setChatlist] = useState([]);
  const [msg, setMsg] = useState('');
  const { user } = useSelector((state) => state.user);
  const [unreadCount, setUnreadCount] = useState(0);
  const [disputeModal, setDisputeModal] = useState(false);

  const showDoc = (docc) => dispatch(showDocumentModal(docc));

  //get Job Details
  const getJobDetails = () => {
    dispatch(showLoading());
    GET(`/jobs/getDetails/${job_id}`)
      .then(({ data }) => {
        setDetails(data.job);
        dispatch(hideLoading());
      })
      .catch((err) => {
        dispatch(showModal(err.message));
        dispatch(hideLoading());
      });
  };

  useEffect(() => {
    getJobDetails();
  }, []);

  // CHAT Related
  const chatName = user.type === 'application_client' ? 'Us' : 'Client';
  const chatBlockId = chatName === 'Client' ? 'chat-tops' : 'chat-top';

  // initialize and subcsribe to chat here
  const handleChatEvent = (data1) => {
    if (data1.chat_type === 'client') {
      if (!chatbox) {
        setUnreadCount((prevState) => prevState + 1);
      }
      setChatlist((prevState) => [...prevState, data1]);
      const objDiv = document.getElementById(chatBlockId);
      if (objDiv) {
        objDiv.scrollTop = objDiv.scrollHeight;
      }
    }
    dispatch(showModal('you have a new message', true));
  };
  useChat(user.uuid, chatbox, handleChatEvent);

  const getChat = () => {
    GET(`/chats/getByJob/${job_id}`)
      .then(({ data }) => {
        if (user.type === 'application_client') {
          const oc = data.chats.operator?.length > 0 ? data.chats.operator.reverse() : [];
          setChatlist(oc);
        } else {
          const cc = data.chats.client?.length > 0 ? data.chats.client.reverse() : [];
          setChatlist(cc);
        }
        const objDiv = document.getElementById(chatBlockId);
        if (objDiv) {
          objDiv.scrollTop = objDiv.scrollHeight;
        }
      })
      .catch((err) => {
        dispatch(showModal(err.message));
      });
  };

  const chatToggle = () => {
    if (!chatbox) {
      getChat();
      setUnreadCount(0);
    }
    setChatbox(!chatbox);
  };

  const sendMessage = () => {
    let message = 'Hi';
    if (!isEmpty(msg)) {
      message = msg;
    }

    const payLoad = {
      job_uuid: job_id,
      sender_uuid: user.uuid,
      message: message,
      chat_type: 'client',
    };
    if (user.type === 'application_client') {
      payLoad.receiver_uuid = jobDetails.operator_uuid;
    } else if (user.type === 'managenmnt_operator') {
      payLoad.receiver_uuid = jobDetails.created_by;
    }

    POST(`/chats/addMessage`, payLoad)
      .then(({ data }) => {
        setChatlist((prevState) => [...prevState, data.chat]);
        const objDiv = document.getElementById(chatBlockId);
        if (objDiv) {
          objDiv.scrollTop = objDiv.scrollHeight;
        }
      })
      .catch((err) => {
        dispatch(showModal(err.message));
      });
  };

  const sendButton = () => {
    sendMessage();
    setMsg('');
  };

  const handleTextChange = (e) => {
    if (e.key === 'Enter') {
      sendMessage();
      setMsg('');
    }
  };

  const handleOnChange = (e) => {
    setMsg(e.target.value);
  };

  const handleDeleteJob = () => {
    swal({
      title: 'Are you sure?',
      text: `Are you sure you want to Delete Job?`,
      icon: 'warning',
      buttons: ['No', 'Yes'],
    }).then((result) => {
      if (result) {
        dispatch(showLoading());
        DELETE(`/jobs/${job_id}`)
          .then(() => {
            dispatch(showModal('Job Deleted Sucessfully!', true));
            dispatch(hideLoading());
            props.history.goBack();
          })
          .catch((err) => {
            dispatch(hideLoading());
            dispatch(showModal(err.message));
          });
      }
    });
  };

  const toggleDisputeModal = () => setDisputeModal((s) => !s);

  if (isEmpty(serviceData)) {
    return <AppLoader />;
  }

  const jobUnderReview =
    jobDetails.clearing_status === '6' ||
    jobDetails.clearing_status === '11' ||
    jobDetails.forwarding_status === '6';

  const jobStatusRejected =
    jobDetails.clearing_status === '3' ||
    jobDetails.forwarding_status === '3' ||
    jobDetails.clearing_status === '12';

  const rejectedJob = jobStatusRejected && jobDetails.operator_comment;
  const showDeleteJob = rejectedJob || jobUnderReview;

  const showUpdateJob =
    jobDetails.clearing_status === '6' ||
    jobDetails.forwarding_status === '6' ||
    jobDetails.clearing_status === '3' ||
    jobDetails.forwarding_status === '3' ||
    jobDetails.clearing_status === '11' ||
    jobDetails.clearing_status === '12';

  const showOpenDispute =
    jobDetails?.disputes?.length === 0 &&
    (jobDetails?.can_clearing_dispute || jobDetails?.can_forwarding_dispute);

  return (
    <>
      <div id="tabblock4" className="tabcontent rej-job-details">
        <div
          className="bodycont"
          style={{
            background: '#f8f9fa',
            minHeight: '100vh',
            padding: '120px 2rem 2rem',
            maxWidth: '100vw',
            overflowX: 'hidden',
          }}
        >
          {/* Page Header with Gradient */}
          <div
            className="mb-4"
            style={{
              background: 'linear-gradient(135deg, #007679 0%, #01a8af 100%)',
              padding: '2rem 2rem 1.5rem',
              borderRadius: '16px',
              color: 'white',
              boxShadow: '0 8px 30px rgba(0,118,121,0.3)',
              width: '100%',
              boxSizing: 'border-box',
              margin: '0 auto',
              position: 'relative',
              zIndex: 1,
            }}
          >
            <div className="w-100 text-center">
              <div
                style={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: '1.5rem',
                  gap: '0.75rem',
                }}
              >
                <span
                  onClick={() => props.history.goBack()}
                  style={{ cursor: 'pointer', flexShrink: 0 }}
                >
                  <LeftArrowSvg />
                </span>
                <h2
                  style={{
                    margin: 0,
                    fontSize: '2.5rem',
                    fontWeight: '800',
                    lineHeight: '1.2',
                    flex: '1 1 auto',
                    minWidth: '200px',
                    color: 'white',
                  }}
                >
                  <i className="fa fa-briefcase" style={{ marginRight: '12px' }}></i>
                  Job Details
                </h2>
              </div>

              <div
                style={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  gap: '0.75rem',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                {jobDetails.job_type_tags &&
                  jobDetails.job_type_tags.map((y, i) => (
                    <span
                      key={i}
                      style={{
                        display: 'inline-block',
                        backgroundColor: 'rgba(255,255,255,0.25)',
                        backdropFilter: 'blur(10px)',
                        color: '#ffffff',
                        fontSize: '1.2rem',
                        fontWeight: '700',
                        border: '2px solid rgba(255,255,255,0.5)',
                        padding: '0.7rem 1.5rem',
                        borderRadius: '0.5rem',
                        lineHeight: '1.3',
                        letterSpacing: '0.5px',
                      }}
                    >
                      {capitalize(y === 'forwarding' ? 'Transport' : y)} Job
                    </span>
                  ))}
                <span
                  style={{
                    display: 'inline-block',
                    backgroundColor: 'rgba(255,255,255,0.95)',
                    color: '#007679',
                    fontSize: '1.2rem',
                    fontWeight: '700',
                    padding: '0.7rem 1.5rem',
                    borderRadius: '0.5rem',
                    lineHeight: '1.3',
                    letterSpacing: '0.5px',
                  }}
                >
                  {jobDetails.job_id
                    ? `Job ID: ${jobDetails.job_id}-${jobDetails.is_forwarding_only ? 'T' : 'C'}`
                    : 'N/A'}
                </span>
              </div>
            </div>
          </div>

          <div className="servicetab" style={{ marginTop: '2rem' }}>
            <div className="operator-info">
              <div style={{ maxWidth: '1200px', margin: '0 auto' }}>


                {/* Rejection Reason Alert */}
                {rejectedJob && (
                  <div
                    className="alert alert-danger mb-4 border-0"
                    style={{
                      borderRadius: '16px',
                      padding: '1.5rem 2rem',
                      background: 'linear-gradient(135deg, #fff5f5 0%, #fed7d7 100%)',
                      color: '#c53030',
                      boxShadow: '0 8px 20px rgba(220,53,69,0.1)',
                      position: 'relative',
                      overflow: 'hidden'
                    }}
                  >
                    <div
                      style={{
                        position: 'absolute',
                        top: '-20px',
                        right: '-20px',
                        opacity: '0.05',
                        transform: 'rotate(-15deg)'
                      }}
                    >
                      <i className="fa fa-exclamation-triangle" style={{ fontSize: '10rem' }}></i>
                    </div>
                    <div className="d-flex align-items-start position-relative" style={{ zIndex: 1 }}>
                      <div 
                        className="rounded-circle d-flex align-items-center justify-content-center me-3 flex-shrink-0" 
                        style={{ width: '48px', height: '48px', background: 'rgba(220,53,69,0.15)' }}
                      >
                        <i className="fa fa-exclamation-triangle text-danger" style={{ fontSize: '1.4rem' }}></i>
                      </div>
                      <div className="pt-1">
                        <h5 className="fw-bold mb-1 text-danger" style={{ fontSize: '1.6rem' }}>Job Returned</h5>
                        <p className="mb-0 fw-bold" style={{ fontSize: '1.4rem', color: '#9b2c2c' }}>{jobDetails.operator_comment}</p>
                      </div>
                    </div>
                  </div>
                )}

                {/* Category Details Section - Standardized to Operator UI */}
                <div
                  className="card border-0 mb-4"
                  style={{
                    borderRadius: '16px',
                    boxShadow: '0 8px 24px rgba(0,118,121,0.12)',
                    overflow: 'hidden',
                    background: '#ffffff',
                  }}
                >
                  <div
                    className="card-header"
                    style={{
                      background: 'linear-gradient(135deg, #007679 0%, #01a8af 100%)',
                      borderBottom: '3px solid #01a8af',
                      padding: '1.5rem 2rem',
                    }}
                  >
                    <h4
                      className="mb-0"
                      style={{ color: '#ffffff', fontSize: '1.7rem', fontWeight: '700' }}
                    >
                      <i
                        className={`fa ${
                          jobDetails.category === 1
                            ? 'fa-car'
                            : 'fa-cubes'
                        } me-2`}
                        style={{ color: '#ffffff' }}
                      ></i>
                      {jobDetails.category === 1
                        ? 'Vehicle Details'
                        : 'Cargo Details'}
                    </h4>
                  </div>
                    <div className="card-body p-4" style={{ background: '#fafafa' }}>
                      <div className="row g-4">
                        {jobDetails.category === 1 && (
                          <div className="w-100">
                              <div className="row g-4 mb-4">
                                {/* 1. Cargo Category */}
                                <div className={serviceData?.job?.vehicle_type?.[jobDetails.type]?.toLowerCase() === 'roro' ? "col-md-6" : "col-md-4"}>
                                  <div
                                    className="card border-0 h-100"
                                    style={{
                                      borderRadius: '16px',
                                      boxShadow: '0 4px 20px rgba(0,118,121,0.15)',
                                      overflow: 'hidden',
                                    }}
                                  >
                                    <div className="card-body p-4">
                                      <div className="d-flex align-items-center mb-3">
                                        <div
                                          className="rounded-circle d-flex align-items-center justify-content-center me-3"
                                          style={{
                                            width: '50px',
                                            height: '50px',
                                            background: 'linear-gradient(135deg, #007679 0%, #01a8af 100%)',
                                          }}
                                        >
                                          <i
                                            className="fa fa-list text-white"
                                            style={{ fontSize: '1.5rem' }}
                                          ></i>
                                        </div>
                                        <div>
                                          <p
                                            className="text-muted mb-1"
                                            style={{
                                              fontSize: '1.1rem',
                                              fontWeight: '700',
                                              textTransform: 'uppercase',
                                              letterSpacing: '1px',
                                            }}
                                          >
                                            Cargo Category
                                          </p>
                                          <h4 className="mb-0 fw-bold" style={{ color: '#007679', fontSize: '1.2rem' }}>
                                            {capitalize(serviceData.job.category[jobDetails.category]) || 'N/A'}
                                          </h4>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                {/* 2. Type of Vehicle */}
                                <div className={serviceData?.job?.vehicle_type?.[jobDetails.type]?.toLowerCase() === 'roro' ? "col-md-6" : "col-md-4"}>
                                  <div
                                    className="card border-0 h-100"
                                    style={{
                                      borderRadius: '16px',
                                      boxShadow: '0 4px 20px rgba(1,168,175,0.15)',
                                      overflow: 'hidden',
                                    }}
                                  >
                                    <div className="card-body p-4">
                                      <div className="d-flex align-items-center mb-3">
                                        <div
                                          className="rounded-circle d-flex align-items-center justify-content-center me-3"
                                          style={{
                                            width: '50px',
                                            height: '50px',
                                            background: 'linear-gradient(135deg, #01a8af 0%, #1daeb2 100%)',
                                          }}
                                        >
                                          <i className="fa fa-truck text-white" style={{ fontSize: '1.5rem' }}></i>
                                        </div>
                                        <div>
                                          <p
                                            className="text-muted mb-1"
                                            style={{
                                              fontSize: '1.1rem',
                                              fontWeight: '700',
                                              textTransform: 'uppercase',
                                              letterSpacing: '1px',
                                            }}
                                          >
                                            Type of Vehicle
                                          </p>
                                          <h4 className="mb-0 fw-bold" style={{ color: '#01a8af', fontSize: '1.2rem' }}>
                                            {capitalize(serviceData.job.vehicle_type[jobDetails.type]) || 'N/A'}
                                          </h4>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                {/* 3. No of Containers */}
                                {serviceData?.job?.vehicle_type?.[jobDetails.type]?.toLowerCase() !== 'roro' && (
                                  <div className="col-md-4">
                                    <div
                                      className="card border-0 h-100"
                                      style={{
                                        borderRadius: '16px',
                                        boxShadow: '0 4px 20px rgba(29,174,178,0.15)',
                                        overflow: 'hidden',
                                      }}
                                    >
                                      <div className="card-body p-4">
                                        <div className="d-flex align-items-center mb-3">
                                          <div
                                            className="rounded-circle d-flex align-items-center justify-content-center me-3"
                                            style={{
                                              width: '50px',
                                              height: '50px',
                                              background: 'linear-gradient(135deg, #1daeb2 0%, #29bec1 100%)',
                                            }}
                                          >
                                            <i className="fa fa-cubes text-white" style={{ fontSize: '1.5rem' }}></i>
                                          </div>
                                          <div>
                                            <p
                                              className="text-muted mb-1"
                                              style={{
                                                fontSize: '1.1rem',
                                                fontWeight: '700',
                                                textTransform: 'uppercase',
                                                letterSpacing: '1px',
                                              }}
                                            >
                                              No of Containers
                                            </p>
                                            <h4 className="mb-0 fw-bold" style={{ color: '#1daeb2', fontSize: '1.2rem' }}>
                                              {jobDetails.containers?.length || jobDetails.children_packages?.length || jobDetails.no_of_containers || 0}
                                            </h4>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </div>

                              <div className="row g-4 mb-4">
                                <div className="col-md-4">
                                  <div
                                    className="card border-0 h-100"
                                    style={{
                                      borderRadius: '16px',
                                      boxShadow: '0 4px 20px rgba(0,118,121,0.15)',
                                      overflow: 'hidden',
                                    }}
                                  >
                                    <div className="card-body p-4">
                                      <div className="d-flex align-items-center mb-3">
                                        <div
                                          className="rounded-circle d-flex align-items-center justify-content-center me-3"
                                          style={{
                                            width: '50px',
                                            height: '50px',
                                            background: 'linear-gradient(135deg, #007679 0%, #01a8af 100%)',
                                          }}
                                        >
                                          <i
                                            className="fa fa-info-circle text-white"
                                            style={{ fontSize: '1.5rem' }}
                                          ></i>
                                        </div>
                                        <div>
                                          <p
                                            className="text-muted mb-1"
                                            style={{
                                              fontSize: '1.1rem',
                                              fontWeight: '700',
                                              textTransform: 'uppercase',
                                              letterSpacing: '1px',
                                            }}
                                          >
                                            Status
                                          </p>
                                          <h4 className="mb-0 fw-bold" style={{ color: '#007679', fontSize: '1.2rem' }}>
                                            {['suspended', 'rejected'].includes(getJobStatus(jobDetails, serviceData)?.toLowerCase()) ? 'Returned' : getJobStatus(jobDetails, serviceData)}
                                          </h4>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div className="col-md-4">
                                  <div
                                    className="card border-0 h-100"
                                    style={{
                                      borderRadius: '16px',
                                      boxShadow: '0 4px 20px rgba(1,168,175,0.15)',
                                      overflow: 'hidden',
                                    }}
                                  >
                                    <div className="card-body p-4">
                                      <div className="d-flex align-items-center mb-3">
                                        <div
                                          className="rounded-circle d-flex align-items-center justify-content-center me-3"
                                          style={{
                                            width: '50px',
                                            height: '50px',
                                            background: 'linear-gradient(135deg, #01a8af 0%, #1daeb2 100%)',
                                          }}
                                        >
                                          <i className="fa fa-calendar text-white" style={{ fontSize: '1.5rem' }}></i>
                                        </div>
                                        <div>
                                          <p
                                            className="text-muted mb-1"
                                            style={{
                                              fontSize: '1.1rem',
                                              fontWeight: '700',
                                              textTransform: 'uppercase',
                                              letterSpacing: '1px',
                                            }}
                                          >
                                            Expected Arrival
                                          </p>
                                          <h4 className="mb-0 fw-bold" style={{ color: '#01a8af', fontSize: '1.2rem' }}>
                                            {jobDetails.date_of_arrival ? moment(jobDetails.date_of_arrival).format('DD MMM YYYY') : 'N/A'}
                                          </h4>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div className="col-md-4">
                                  <div
                                    className="card border-0 h-100"
                                    style={{
                                      borderRadius: '16px',
                                      boxShadow: '0 4px 20px rgba(29,174,178,0.15)',
                                      overflow: 'hidden',
                                    }}
                                  >
                                    <div className="card-body p-4">
                                      <div className="d-flex align-items-center mb-3">
                                        <div
                                          className="rounded-circle d-flex align-items-center justify-content-center me-3"
                                          style={{
                                            width: '50px',
                                            height: '50px',
                                            background: 'linear-gradient(135deg, #1daeb2 0%, #29bec1 100%)',
                                          }}
                                        >
                                          <i className="fa fa-ship text-white" style={{ fontSize: '1.5rem' }}></i>
                                        </div>
                                        <div>
                                          <p
                                            className="text-muted mb-1"
                                            style={{
                                              fontSize: '1.1rem',
                                              fontWeight: '700',
                                              textTransform: 'uppercase',
                                              letterSpacing: '1px',
                                            }}
                                          >
                                            Port of Discharge
                                          </p>
                                          <h4 className="mb-0 fw-bold" style={{ color: '#1daeb2', fontSize: '1.2rem' }}>
                                            {getPortName(jobDetails?.clearing_discharge_port || jobDetails.port_of_discharge, serviceData)}
                                          </h4>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                            {((jobDetails.containers && jobDetails.containers.length > 0) || 
                              (jobDetails.children_packages && jobDetails.children_packages.length > 0) || 
                              (serviceData?.job?.vehicle_type?.[jobDetails.type]?.toLowerCase() === 'roro' && jobDetails.vehicles && jobDetails.vehicles.length > 0)) ? (
                              ((jobDetails.containers && jobDetails.containers.length > 0) 
                                ? jobDetails.containers 
                                : (jobDetails.children_packages && jobDetails.children_packages.length > 0) 
                                  ? jobDetails.children_packages 
                                  : (serviceData?.job?.vehicle_type?.[jobDetails.type]?.toLowerCase() === 'roro' ? [{ vehicles: jobDetails.vehicles, isRoro: true, load_description: jobDetails.load_description }] : [])
                              ).map((x, index) => (
                                <div key={index} className={index > 0 ? 'mt-5' : 'mt-4'}>
                                  {!x.isRoro && (
                                    <div className="p-3 mb-4 rounded-4" style={{ background: 'linear-gradient(135deg, #007679 0%, #01a8af 100%)', color: 'white', boxShadow: '0 4px 12px rgba(0,118,121,0.2)' }}>
                                      <h4
                                        className="fw-bold mb-0"
                                        style={{ color: '#ffffff', fontSize: '1.5rem' }}
                                      >
                                        <i className={`fa ${x.isRoro ? 'fa-car' : 'fa-cube'} me-2`}></i>
                                        {x.isRoro ? 'Vehicle Details' : `Container ${index + 1}`}
                                      </h4>
                                    </div>
                                  )}

                                  {!x.isRoro && (
                                    <div className="row g-4 mb-4">
                                      <div className="col-md-4">
                                        <div
                                          className="p-4 rounded-4 h-100 text-center"
                                          style={{
                                            background: 'linear-gradient(135deg, #007679 0%, #01a8af 100%)',
                                            color: 'white',
                                          }}
                                        >
                                          <p
                                            className="mb-2"
                                            style={{
                                              fontSize: '1.4rem',
                                              fontWeight: '700',
                                              textTransform: 'uppercase',
                                              letterSpacing: '0.5px',
                                            }}
                                          >
                                            <i className="fa fa-arrows-alt me-2"></i>Size of Container
                                          </p>
                                          <h3
                                            className="mb-0 fw-bold"
                                            style={{ fontSize: '1.5rem', color: 'white' }}
                                          >
                                            {x.size_of_container || x.size || x.vehicles?.[0]?.size_of_container || jobDetails.size || 'N/A'}
                                          </h3>
                                        </div>
                                      </div>

                                      <div className="col-md-4">
                                        <div
                                          className="p-4 rounded-4 h-100 text-center"
                                          style={{
                                            background: 'linear-gradient(135deg, #e8f5f5 0%, #d4efef 100%)',
                                            borderLeft: '6px solid #1daeb2',
                                          }}
                                        >
                                          <p
                                            className="mb-2 text-center"
                                            style={{
                                              fontSize: '1.4rem',
                                              fontWeight: '700',
                                              color: '#1daeb2',
                                              textTransform: 'uppercase',
                                              letterSpacing: '0.5px',
                                            }}
                                          >
                                            <i className="fa fa-car me-2"></i>Number of Vehicles
                                          </p>
                                          <h4
                                            className="mb-0 fw-bold text-center"
                                            style={{ color: '#1daeb2', fontSize: '1.5rem' }}
                                          >
                                            {x.vehicles?.length || 0}
                                          </h4>
                                        </div>
                                      </div>

                                      <div className="col-md-4">
                                        <div
                                          className="p-4 rounded-4 h-100 text-center"
                                          style={{
                                            background: 'linear-gradient(135deg, #f0f9f9 0%, #e0f2f2 100%)',
                                            borderLeft: '6px solid #01a8af',
                                          }}
                                        >
                                          <p
                                            className="mb-2 text-center"
                                            style={{
                                              fontSize: '1.4rem',
                                              fontWeight: '700',
                                              color: '#01a8af',
                                              textTransform: 'uppercase',
                                              letterSpacing: '0.5px',
                                            }}
                                          >
                                            <i className="fa fa-list me-2"></i>Description of added items
                                          </p>
                                          <h3
                                            className="mb-0 fw-bold text-center"
                                            style={{ fontSize: '1.5rem', color: '#004d4d' }}
                                          >
                                            {x.load_description || x.item_name || 'N/A'}
                                          </h3>
                                        </div>
                                      </div>
                                    </div>
                                  )}

                                  {x.vehicles && x.vehicles.length > 0 && (
                                    <div className="row g-4">
                                      {x.vehicles.map((v, i) => (
                                        <div className="col-lg-6 col-sm-12" key={i}>
                                          <div
                                            className="card border-0 h-100"
                                            style={{
                                              background: '#ffffff',
                                              borderRadius: '20px',
                                              boxShadow: '0 4px 15px rgba(1,168,175,0.15)',
                                              overflow: 'hidden',
                                            }}
                                          >
                                            <div
                                              className="card-header"
                                              style={{
                                                background: 'linear-gradient(135deg, #01a8af 0%, #1daeb2 100%)',
                                                padding: '1.25rem 1.5rem',
                                                border: 'none',
                                              }}
                                            >
                                              <div className="d-flex justify-content-between align-items-center">
                                                <h5
                                                  className="mb-0 fw-bold text-white"
                                                  style={{ fontSize: '1.5rem' }}
                                                >
                                                  {jobDetails.type === 1
                                                    ? 'Vehicle Information'
                                                    : `Vehicle ${i + 1}`}
                                                </h5>
                                                <span
                                                  className="badge bg-white"
                                                  style={{
                                                    color: '#01a8af',
                                                    fontSize: '1rem',
                                                    fontWeight: '700',
                                                    padding: '0.5rem 1rem',
                                                    borderRadius: '8px',
                                                  }}
                                                >
                                                  #{i + 1}
                                                </span>
                                              </div>
                                            </div>
                                            <div className="card-body p-4">
                                              <div className="row g-3">
                                                <div className="col-6">
                                                  <div className="p-3 rounded-4 bg-light border">
                                                    <p className="text-muted text-uppercase fw-bold mb-1" style={{ fontSize: '1.3rem' }}>Brand</p>
                                                    <p className="mb-0 fw-bold" style={{ color: '#2c3e50', fontSize: '1.4rem' }}>{v.brand || 'N/A'}</p>
                                                  </div>
                                                </div>
                                                <div className="col-6">
                                                  <div className="p-3 rounded-4 bg-light border">
                                                    <p className="text-muted text-uppercase fw-bold mb-1" style={{ fontSize: '1.3rem' }}>Year</p>
                                                    <p className="mb-0 fw-bold" style={{ color: '#2c3e50', fontSize: '1.4rem' }}>{v.year || 'N/A'}</p>
                                                  </div>
                                                </div>
                                                <div className="col-6">
                                                  <div className="p-3 rounded-4 bg-light border">
                                                    <p className="text-muted text-uppercase fw-bold mb-1" style={{ fontSize: '1.3rem' }}>Model</p>
                                                    <p className="mb-0 fw-bold" style={{ color: '#2c3e50', fontSize: '1.4rem' }}>{v.model || 'N/A'}</p>
                                                  </div>
                                                </div>
                                                <div className="col-6">
                                                  <div className="p-3 rounded-4 bg-light border">
                                                    <p className="text-muted text-uppercase fw-bold mb-1" style={{ fontSize: '1.3rem' }}>Condition</p>
                                                    <p className="mb-0 fw-bold" style={{ color: '#2c3e50', fontSize: '1.4rem' }}>{capitalize(serviceData.job.vehicle_state[v.vehicle_state]) || 'N/A'}</p>
                                                  </div>
                                                </div>
                                                <div className="col-12">
                                                  <div className="p-3 rounded-4 bg-light border">
                                                    <p className="text-muted text-uppercase fw-bold mb-1" style={{ fontSize: '1.3rem' }}>VREG Number</p>
                                                    <p className="mb-0 fw-bold" style={{ color: '#2c3e50', fontSize: '1.4rem' }}>{v.vreg_no || 'N/A'}</p>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      ))}
                                    </div>
                                  )}
                                </div>
                              ))
                            ) : (
                              serviceData?.job?.vehicle_type?.[jobDetails.type]?.toLowerCase() !== 'roro' && (
                                <div className="text-center p-5">
                                    <i className="fa fa-info-circle fa-3x mb-3" style={{ color: '#01a8af', opacity: 0.5 }}></i>
                                    <p className="text-muted fw-bold">No nested container data found.</p>
                                </div>
                              )
                            )}
                          </div>
                        )}
                        {jobDetails.category === 2 && (
                          <div className="w-100">
                            <div className="row g-4 mb-4">
                              {/* 1. Cargo Category */}
                              <div className="col-md-4">
                                <div
                                  className="card border-0 h-100"
                                  style={{
                                    borderRadius: '16px',
                                    boxShadow: '0 4px 20px rgba(0,118,121,0.15)',
                                    overflow: 'hidden',
                                  }}
                                >
                                  <div className="card-body p-4">
                                    <div className="d-flex align-items-center mb-3">
                                      <div
                                        className="rounded-circle d-flex align-items-center justify-content-center me-3"
                                        style={{
                                          width: '50px',
                                          height: '50px',
                                          background: 'linear-gradient(135deg, #007679 0%, #01a8af 100%)',
                                        }}
                                      >
                                        <i
                                          className="fa fa-list text-white"
                                          style={{ fontSize: '1.5rem' }}
                                        ></i>
                                      </div>
                                      <div>
                                        <p
                                          className="text-muted mb-1"
                                          style={{
                                            fontSize: '1.1rem',
                                            fontWeight: '700',
                                            textTransform: 'uppercase',
                                            letterSpacing: '1px',
                                          }}
                                        >
                                          Cargo Category
                                        </p>
                                        <h4 className="mb-0 fw-bold" style={{ color: '#007679', fontSize: '1.2rem' }}>
                                          {capitalize(serviceData.job.category[jobDetails.category]) || 'N/A'}
                                        </h4>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              {/* 2. Type of Cargo */}
                              <div className="col-md-4">
                                <div
                                  className="card border-0 h-100"
                                  style={{
                                    borderRadius: '16px',
                                    boxShadow: '0 4px 20px rgba(1,168,175,0.15)',
                                    overflow: 'hidden',
                                  }}
                                >
                                  <div className="card-body p-4">
                                    <div className="d-flex align-items-center mb-3">
                                      <div
                                        className="rounded-circle d-flex align-items-center justify-content-center me-3"
                                        style={{
                                          width: '50px',
                                          height: '50px',
                                          background: 'linear-gradient(135deg, #01a8af 0%, #1daeb2 100%)',
                                        }}
                                      >
                                        <i className="fa fa-cubes text-white" style={{ fontSize: '1.5rem' }}></i>
                                      </div>
                                      <div>
                                        <p
                                          className="text-muted mb-1"
                                          style={{
                                            fontSize: '1.1rem',
                                            fontWeight: '700',
                                            textTransform: 'uppercase',
                                            letterSpacing: '1px',
                                          }}
                                        >
                                          Type of Cargo
                                        </p>
                                        <h4 className="mb-0 fw-bold" style={{ color: '#01a8af', fontSize: '1.2rem' }}>
                                          {accessGeneralOrCargoType(jobDetails, serviceData)}
                                        </h4>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              {/* 3. No of Containers */}
                              <div className="col-md-4">
                                <div
                                  className="card border-0 h-100"
                                  style={{
                                    borderRadius: '16px',
                                    boxShadow: '0 4px 20px rgba(29,174,178,0.15)',
                                    overflow: 'hidden',
                                  }}
                                >
                                  <div className="card-body p-4">
                                    <div className="d-flex align-items-center mb-3">
                                      <div
                                        className="rounded-circle d-flex align-items-center justify-content-center me-3"
                                        style={{
                                          width: '50px',
                                          height: '50px',
                                          background: 'linear-gradient(135deg, #1daeb2 0%, #29bec1 100%)',
                                        }}
                                      >
                                        <i className="fa fa-ship text-white" style={{ fontSize: '1.5rem' }}></i>
                                      </div>
                                      <div>
                                        <p
                                          className="text-muted mb-1"
                                          style={{
                                            fontSize: '1.1rem',
                                            fontWeight: '700',
                                            textTransform: 'uppercase',
                                            letterSpacing: '1px',
                                          }}
                                        >
                                          No of Containers
                                        </p>
                                        <h4 className="mb-0 fw-bold" style={{ color: '#1daeb2', fontSize: '1.2rem' }}>
                                          {jobDetails.no_of_containers}
                                        </h4>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="row g-4 mb-4">
                              <div className="col-md-4">
                                <div
                                  className="card border-0 h-100"
                                  style={{
                                    borderRadius: '16px',
                                    boxShadow: '0 4px 20px rgba(0,118,121,0.15)',
                                    overflow: 'hidden',
                                  }}
                                >
                                  <div className="card-body p-4">
                                    <div className="d-flex align-items-center mb-3">
                                      <div
                                        className="rounded-circle d-flex align-items-center justify-content-center me-3"
                                        style={{
                                          width: '50px',
                                          height: '50px',
                                          background: 'linear-gradient(135deg, #007679 0%, #01a8af 100%)',
                                        }}
                                      >
                                        <i
                                          className="fa fa-info-circle text-white"
                                          style={{ fontSize: '1.5rem' }}
                                        ></i>
                                      </div>
                                      <div>
                                        <p
                                          className="text-muted mb-1"
                                          style={{
                                            fontSize: '1.1rem',
                                            fontWeight: '700',
                                            textTransform: 'uppercase',
                                            letterSpacing: '1px',
                                          }}
                                        >
                                          Status
                                        </p>
                                        <h4 className="mb-0 fw-bold" style={{ color: '#007679', fontSize: '1.2rem' }}>
                                          {['suspended', 'rejected'].includes(getJobStatus(jobDetails, serviceData)?.toLowerCase()) ? 'Returned' : getJobStatus(jobDetails, serviceData)}
                                        </h4>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div className="col-md-4">
                                <div
                                  className="card border-0 h-100"
                                  style={{
                                    borderRadius: '16px',
                                    boxShadow: '0 4px 20px rgba(1,168,175,0.15)',
                                    overflow: 'hidden',
                                  }}
                                >
                                  <div className="card-body p-4">
                                    <div className="d-flex align-items-center mb-3">
                                      <div
                                        className="rounded-circle d-flex align-items-center justify-content-center me-3"
                                        style={{
                                          width: '50px',
                                          height: '50px',
                                          background: 'linear-gradient(135deg, #01a8af 0%, #1daeb2 100%)',
                                        }}
                                      >
                                        <i className="fa fa-calendar text-white" style={{ fontSize: '1.5rem' }}></i>
                                      </div>
                                      <div>
                                        <p
                                          className="text-muted mb-1"
                                          style={{
                                            fontSize: '1.1rem',
                                            fontWeight: '700',
                                            textTransform: 'uppercase',
                                            letterSpacing: '1px',
                                          }}
                                        >
                                          Expected Arrival
                                        </p>
                                        <h4 className="mb-0 fw-bold" style={{ color: '#01a8af', fontSize: '1.2rem' }}>
                                          {jobDetails.date_of_arrival ? moment(jobDetails.date_of_arrival).format('DD MMM YYYY') : 'N/A'}
                                        </h4>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div className="col-md-4">
                                <div
                                  className="card border-0 h-100"
                                  style={{
                                    borderRadius: '16px',
                                    boxShadow: '0 4px 20px rgba(29,174,178,0.15)',
                                    overflow: 'hidden',
                                  }}
                                >
                                  <div className="card-body p-4">
                                    <div className="d-flex align-items-center mb-3">
                                      <div
                                        className="rounded-circle d-flex align-items-center justify-content-center me-3"
                                        style={{
                                          width: '50px',
                                          height: '50px',
                                          background: 'linear-gradient(135deg, #1daeb2 0%, #29bec1 100%)',
                                        }}
                                      >
                                        <i className="fa fa-ship text-white" style={{ fontSize: '1.5rem' }}></i>
                                      </div>
                                      <div>
                                        <p
                                          className="text-muted mb-1"
                                          style={{
                                            fontSize: '1.1rem',
                                            fontWeight: '700',
                                            textTransform: 'uppercase',
                                            letterSpacing: '1px',
                                          }}
                                        >
                                          Port of Discharge
                                        </p>
                                        <h4 className="mb-0 fw-bold" style={{ color: '#1daeb2', fontSize: '1.2rem' }}>
                                          {getPortName(jobDetails?.clearing_discharge_port || jobDetails.port_of_discharge, serviceData)}
                                        </h4>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            {jobDetails.containers && jobDetails.containers.length > 0 && (
                              <div className="mt-4">
                                {jobDetails.containers.map((x, index) => (
                                  <div key={index} className={index > 0 ? 'mt-5' : 'mt-0'}>
                                    <div className="p-3 mb-4 rounded-4" style={{ background: 'linear-gradient(135deg, #007679 0%, #01a8af 100%)', color: 'white', boxShadow: '0 4px 12px rgba(0,118,121,0.2)' }}>
                                      <h4
                                        className="fw-bold mb-0"
                                        style={{ color: '#ffffff', fontSize: '1.5rem' }}
                                      >
                                        <i className="fa fa-cube me-2"></i>Container {index + 1}
                                      </h4>
                                    </div>

                                    <div className="row g-4">
                                      {/* 1. Size of Container */}
                                      <div className="col-md-6">
                                        <div
                                          className="p-4 rounded-4 h-100 text-center"
                                          style={{
                                            background: 'linear-gradient(135deg, #007679 0%, #01a8af 100%)',
                                            color: 'white',
                                            boxShadow: '0 4px 15px rgba(0,118,121,0.2)',
                                          }}
                                        >
                                          <p
                                            className="mb-2"
                                            style={{
                                              fontSize: '1.4rem',
                                              fontWeight: '700',
                                              textTransform: 'uppercase',
                                              letterSpacing: '0.5px',
                                            }}
                                          >
                                            <i className="fa fa-arrows-alt me-2"></i>Size of Container
                                          </p>
                                          <h3
                                            className="mb-0 fw-bold"
                                            style={{ fontSize: '1.5rem', color: 'white' }}
                                          >
                                            {serviceData.truck?.size[x.size_of_container || x.size || x.vehicles?.[0]?.size_of_container] ||
                                             x.size_of_container ||
                                             x.size ||
                                             x.vehicles?.[0]?.size_of_container ||
                                             x.container_size ||
                                             x.truck_size ||
                                             x.container_type ||
                                             jobDetails.size ||
                                             'N/A'}
                                          </h3>
                                        </div>
                                      </div>

                                      {/* 2. Item Title */}
                                      <div className="col-md-6">
                                        <div
                                          className="p-4 rounded-4 h-100"
                                          style={{
                                            background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
                                            borderLeft: '6px solid #6c757d',
                                            border: '1px solid #dee2e6',
                                          }}
                                        >
                                          <p
                                            className="mb-2"
                                            style={{
                                              fontSize: '1.4rem',
                                              fontWeight: '700',
                                              color: '#6c757d',
                                              textTransform: 'uppercase',
                                              letterSpacing: '0.5px',
                                            }}
                                          >
                                            <i className="fa fa-list me-2"></i>Item Title
                                          </p>
                                          <h3
                                            className="mb-0 fw-bold"
                                            style={{ color: '#212529', fontSize: '1.4rem' }}
                                          >
                                            {x.item_name || x.load_description || 'N/A'}
                                          </h3>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            )}
                          </div>
                        )}
                        {jobDetails.category === 3 && (
                          <>
                            <div className="row g-4 mb-4">
                              {/* 1. Cargo Category */}
                              <div className="col-md-4">
                                <div
                                  className="card border-0 h-100"
                                  style={{
                                    borderRadius: '16px',
                                    boxShadow: '0 4px 20px rgba(0,118,121,0.15)',
                                    overflow: 'hidden',
                                  }}
                                >
                                  <div className="card-body p-4">
                                    <div className="d-flex align-items-center mb-3">
                                      <div
                                        className="rounded-circle d-flex align-items-center justify-content-center me-3"
                                        style={{
                                          width: '50px',
                                          height: '50px',
                                          background: 'linear-gradient(135deg, #007679 0%, #01a8af 100%)',
                                        }}
                                      >
                                        <i
                                          className="fa fa-list text-white"
                                          style={{ fontSize: '1.5rem' }}
                                        ></i>
                                      </div>
                                      <div>
                                        <p
                                          className="text-muted mb-1"
                                          style={{
                                            fontSize: '1.1rem',
                                            fontWeight: '700',
                                            textTransform: 'uppercase',
                                            letterSpacing: '1px',
                                          }}
                                        >
                                          Cargo Category
                                        </p>
                                        <h4 className="mb-0 fw-bold" style={{ color: '#007679', fontSize: '1.2rem' }}>
                                          {capitalize(serviceData.job.category[jobDetails.category]) || 'N/A'}
                                        </h4>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              {/* Cargo Type */}
                              <div className="col-md-4">
                                <div
                                  className="card border-0 h-100"
                                  style={{
                                    borderRadius: '16px',
                                    boxShadow: '0 4px 20px rgba(1,168,175,0.15)',
                                    overflow: 'hidden',
                                  }}
                                >
                                  <div className="card-body p-4">
                                    <div className="d-flex align-items-center mb-3">
                                      <div
                                        className="rounded-circle d-flex align-items-center justify-content-center me-3"
                                        style={{
                                          width: '50px',
                                          height: '50px',
                                          background: 'linear-gradient(135deg, #01a8af 0%, #1daeb2 100%)',
                                        }}
                                      >
                                        <i className="fa fa-cubes text-white" style={{ fontSize: '1.5rem' }}></i>
                                      </div>
                                      <div>
                                        <p
                                          className="text-muted mb-1"
                                          style={{
                                            fontSize: '1.1rem',
                                            fontWeight: '700',
                                            textTransform: 'uppercase',
                                            letterSpacing: '1px',
                                          }}
                                        >
                                          Type of Cargo
                                        </p>
                                        <h4 className="mb-0 fw-bold" style={{ color: '#01a8af', fontSize: '1.2rem' }}>
                                          {accessGeneralOrCargoType(jobDetails, serviceData)}
                                        </h4>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              {/* 2. Item Name */}
                              <div className="col-md-4">
                                <div
                                  className="card border-0 h-100"
                                  style={{
                                    borderRadius: '16px',
                                    boxShadow: '0 4px 20px rgba(1,168,175,0.15)',
                                    overflow: 'hidden',
                                  }}
                                >
                                  <div className="card-body p-4">
                                    <div className="d-flex align-items-center mb-3">
                                      <div
                                        className="rounded-circle d-flex align-items-center justify-content-center me-3"
                                        style={{
                                          width: '50px',
                                          height: '50px',
                                          background: 'linear-gradient(135deg, #01a8af 0%, #1daeb2 100%)',
                                        }}
                                      >
                                        <i className="fa fa-tag text-white" style={{ fontSize: '1.5rem' }}></i>
                                      </div>
                                      <div>
                                        <p
                                          className="text-muted mb-1"
                                          style={{
                                            fontSize: '1.1rem',
                                            fontWeight: '700',
                                            textTransform: 'uppercase',
                                            letterSpacing: '1px',
                                          }}
                                        >
                                          Item Name
                                        </p>
                                        <h4 className="mb-0 fw-bold" style={{ color: '#01a8af', fontSize: '1.2rem' }}>
                                          {jobDetails.single_item_title || 'N/A'}
                                        </h4>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              {/* 3. Tonnage */}
                              <div className="col-md-4">
                                <div
                                  className="card border-0 h-100"
                                  style={{
                                    borderRadius: '16px',
                                    boxShadow: '0 4px 20px rgba(29,174,178,0.15)',
                                    overflow: 'hidden',
                                  }}
                                >
                                  <div className="card-body p-4">
                                    <div className="d-flex align-items-center mb-3">
                                      <div
                                        className="rounded-circle d-flex align-items-center justify-content-center me-3"
                                        style={{
                                          width: '50px',
                                          height: '50px',
                                          background: 'linear-gradient(135deg, #1daeb2 0%, #29bec1 100%)',
                                        }}
                                      >
                                        <i className="fa fa-balance-scale text-white" style={{ fontSize: '1.5rem' }}></i>
                                      </div>
                                      <div>
                                        <p
                                          className="text-muted mb-1"
                                          style={{
                                            fontSize: '1.1rem',
                                            fontWeight: '700',
                                            textTransform: 'uppercase',
                                            letterSpacing: '1px',
                                          }}
                                        >
                                          Tonnage
                                        </p>
                                        <h4 className="mb-0 fw-bold" style={{ color: '#1daeb2', fontSize: '1.2rem' }}>
                                          {jobDetails.tonnage}
                                        </h4>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div className="col-md-4">
                              <div
                                className="card border-0 h-100"
                                style={{
                                  borderRadius: '16px',
                                  boxShadow: '0 4px 20px rgba(0,118,121,0.15)',
                                  overflow: 'hidden',
                                }}
                              >
                                <div className="card-body p-4">
                                  <div className="d-flex align-items-center mb-3">
                                    <div
                                      className="rounded-circle d-flex align-items-center justify-content-center me-3"
                                      style={{
                                        width: '50px',
                                        height: '50px',
                                        background: 'linear-gradient(135deg, #007679 0%, #01a8af 100%)',
                                      }}
                                    >
                                      <i
                                        className="fa fa-info-circle text-white"
                                        style={{ fontSize: '1.5rem' }}
                                      ></i>
                                    </div>
                                    <div>
                                      <p
                                        className="text-muted mb-1"
                                        style={{
                                          fontSize: '1.1rem',
                                          fontWeight: '700',
                                          textTransform: 'uppercase',
                                          letterSpacing: '1px',
                                        }}
                                      >
                                        Status
                                      </p>
                                      <h4 className="mb-0 fw-bold" style={{ color: '#007679', fontSize: '1.2rem' }}>
                                        {['suspended', 'rejected'].includes(getJobStatus(jobDetails, serviceData)?.toLowerCase()) ? 'Returned' : getJobStatus(jobDetails, serviceData)}
                                      </h4>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="col-md-4">
                              <div
                                className="card border-0 h-100"
                                style={{
                                  borderRadius: '16px',
                                  boxShadow: '0 4px 20px rgba(1,168,175,0.15)',
                                  overflow: 'hidden',
                                }}
                              >
                                <div className="card-body p-4">
                                  <div className="d-flex align-items-center mb-3">
                                    <div
                                      className="rounded-circle d-flex align-items-center justify-content-center me-3"
                                      style={{
                                        width: '50px',
                                        height: '50px',
                                        background: 'linear-gradient(135deg, #01a8af 0%, #1daeb2 100%)',
                                      }}
                                    >
                                      <i className="fa fa-calendar text-white" style={{ fontSize: '1.5rem' }}></i>
                                    </div>
                                    <div>
                                      <p
                                        className="text-muted mb-1"
                                        style={{
                                          fontSize: '1.1rem',
                                          fontWeight: '700',
                                          textTransform: 'uppercase',
                                          letterSpacing: '1px',
                                        }}
                                      >
                                        Expected Arrival
                                      </p>
                                      <h4 className="mb-0 fw-bold" style={{ color: '#01a8af', fontSize: '1.2rem' }}>
                                        {jobDetails.date_of_arrival ? moment(jobDetails.date_of_arrival).format('DD MMM YYYY') : 'N/A'}
                                      </h4>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="col-md-4">
                              <div
                                className="card border-0 h-100"
                                style={{
                                  borderRadius: '16px',
                                  boxShadow: '0 4px 20px rgba(29,174,178,0.15)',
                                  overflow: 'hidden',
                                }}
                              >
                                <div className="card-body p-4">
                                  <div className="d-flex align-items-center mb-3">
                                    <div
                                      className="rounded-circle d-flex align-items-center justify-content-center me-3"
                                      style={{
                                        width: '50px',
                                        height: '50px',
                                        background: 'linear-gradient(135deg, #1daeb2 0%, #29bec1 100%)',
                                      }}
                                    >
                                      <i className="fa fa-ship text-white" style={{ fontSize: '1.5rem' }}></i>
                                    </div>
                                    <div>
                                      <p
                                        className="text-muted mb-1"
                                        style={{
                                          fontSize: '1.1rem',
                                          fontWeight: '700',
                                          textTransform: 'uppercase',
                                          letterSpacing: '1px',
                                        }}
                                      >
                                        Port of Discharge
                                      </p>
                                      <h4 className="mb-0 fw-bold" style={{ color: '#1daeb2', fontSize: '1.2rem' }}>
                                        {getPortName(jobDetails?.clearing_discharge_port || jobDetails.port_of_discharge, serviceData)}
                                      </h4>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                        )}
                      </div>
                    </div>
                  </div>



                {/* Documents Section */}
                {(jobDetails.paar_link || jobDetails.lading_link || jobDetails.performa_invoice || jobDetails.marine_inspection_report) && (
                  <div
                    className="card border-0 mb-4"
                    style={{
                      borderRadius: '16px',
                      boxShadow: '0 8px 24px rgba(0,118,121,0.12)',
                      overflow: 'hidden',
                      background: '#ffffff',
                    }}
                  >
                    <div
                      className="card-header"
                      style={{
                        background: 'linear-gradient(135deg, #007679 0%, #01a8af 100%)',
                        borderBottom: '3px solid #1daeb2',
                        padding: '1.5rem 2rem',
                      }}
                    >
                      <h4
                        className="mb-0"
                        style={{ color: '#ffffff', fontSize: '1.4rem', fontWeight: '700' }}
                      >
                        <i
                          className="fa fa-file-text"
                          style={{ marginRight: '8px', color: '#ffffff' }}
                        ></i>
                        Documents
                      </h4>
                    </div>
                    <div className="card-body p-4" style={{ background: '#fafafa' }}>
                      <div className="row g-4 justify-content-center">
                        {jobDetails.paar_link && (
                          <div className="col-lg-3 col-md-6">
                            <div
                              className="text-center p-4 rounded-4 h-100"
                              style={{
                                background: '#f8f9fa',
                                border: '2px solid #e0e0e0',
                                cursor: 'pointer',
                                transition: 'all 0.3s ease',
                              }}
                              onClick={() => showDoc(jobDetails.paar_link)}
                            >
                              <i
                                className="fa fa-file-pdf-o mb-3 d-block"
                                style={{ fontSize: '3rem', color: '#007679' }}
                              ></i>
                              <p
                                className="mb-0 fw-bold"
                                style={{ fontSize: '1rem', color: '#2c3e50' }}
                              >
                                PAAR Document
                              </p>
                            </div>
                          </div>
                        )}
                        {jobDetails.lading_link && (
                          <div className="col-lg-3 col-md-6">
                            <div
                              className="text-center p-4 rounded-4 h-100"
                              style={{
                                background: '#f8f9fa',
                                border: '2px solid #e0e0e0',
                                cursor: 'pointer',
                                transition: 'all 0.3s ease',
                              }}
                              onClick={() => showDoc(jobDetails.lading_link)}
                            >
                              <i
                                className="fa fa-file-pdf-o mb-3 d-block"
                                style={{ fontSize: '3rem', color: '#01a8af' }}
                              ></i>
                              <p
                                className="mb-0 fw-bold"
                                style={{ fontSize: '1rem', color: '#2c3e50' }}
                              >
                                Bill of Lading
                              </p>
                            </div>
                          </div>
                        )}
                        {jobDetails.performa_invoice && (
                          <div className="col-lg-3 col-md-6">
                            <div
                              className="text-center p-4 rounded-4 h-100"
                              style={{
                                background: '#f8f9fa',
                                border: '2px solid #e0e0e0',
                                cursor: 'pointer',
                                transition: 'all 0.3s ease',
                              }}
                              onClick={() => showDoc(jobDetails.performa_invoice)}
                            >
                              <i
                                className="fa fa-file-pdf-o mb-3 d-block"
                                style={{ fontSize: '3rem', color: '#1daeb2' }}
                              ></i>
                              <p
                                className="mb-0 fw-bold"
                                style={{ fontSize: '1rem', color: '#2c3e50' }}
                              >
                                Proforma Invoice
                              </p>
                            </div>
                          </div>
                        )}
                        {jobDetails.marine_inspection_report && (
                          <div className="col-lg-3 col-md-6">
                            <div
                              className="text-center p-4 rounded-4 h-100"
                              style={{
                                background: '#f8f9fa',
                                border: '2px solid #e0e0e0',
                                cursor: 'pointer',
                                transition: 'all 0.3s ease',
                              }}
                              onClick={() => showDoc(jobDetails.marine_inspection_report)}
                            >
                              <i
                                className="fa fa-file-pdf-o mb-3 d-block"
                                style={{ fontSize: '3rem', color: '#29bec1' }}
                              ></i>
                              <p
                                className="mb-0 fw-bold"
                                style={{ fontSize: '1rem', color: '#2c3e50' }}
                              >
                                Marine Insurance
                              </p>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                )}

                {/* Transport Section */}
                {jobDetails.has_forwarding === 1 && (
                  <div
                    className="card border-0 mb-4"
                    style={{
                      borderRadius: '16px',
                      boxShadow: '0 8px 24px rgba(0,118,121,0.12)',
                      overflow: 'hidden',
                      background: '#ffffff',
                    }}
                  >
                    <div
                      className="card-header"
                      style={{
                        background: 'linear-gradient(135deg, #007679 0%, #01a8af 100%)',
                        borderBottom: '3px solid #007679',
                        padding: '1.5rem 2rem',
                      }}
                    >
                      <h4
                        className="mb-0"
                        style={{ color: '#ffffff', fontSize: '1.4rem', fontWeight: '700' }}
                      >
                        <i
                          className="fa fa-truck"
                          style={{ marginRight: '8px', color: '#ffffff' }}
                        ></i>
                        Transport Details
                      </h4>
                    </div>
                    <div className="card-body p-4">
                      <div className="row g-4">
                        <div className="col-md-6">
                          <div
                            className="p-4 rounded-4 bg-white border-start border-5 border-info shadow-sm"
                          >
                            <p className="text-muted small fw-bold text-uppercase mb-1">Pick-up Location</p>
                            <h5 className="fw-bold mb-0" style={{ color: '#007679' }}>
                              {jobDetails.pickup_location || 'N/A'}
                            </h5>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div
                            className="p-4 rounded-4 bg-white border-start border-5 border-info shadow-sm"
                          >
                            <p className="text-muted small fw-bold text-uppercase mb-1">Destination</p>
                            <h5 className="fw-bold mb-0" style={{ color: '#007679' }}>
                              {jobDetails.destination || 'N/A'}
                            </h5>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {/* Unbundled Jobs - Standardized to Operator UI */}
                {jobDetails.children_packages && jobDetails.children_packages.length > 0 && (
                  <div
                    className="card border-0 mb-4"
                    style={{
                      borderRadius: '16px',
                      boxShadow: '0 8px 24px rgba(0,118,121,0.12)',
                      overflow: 'hidden',
                      background: '#ffffff',
                    }}
                  >
                    <div
                      className="card-header"
                      style={{
                        background: 'linear-gradient(135deg, #007679 0%, #01a8af 100%)',
                        borderBottom: '3px solid #1daeb2',
                        padding: '1.5rem 2rem',
                      }}
                    >
                      <h4
                        className="mb-0"
                        style={{ color: '#ffffff', fontSize: '1.4rem', fontWeight: '700' }}
                      >
                        <i
                          className="fa fa-sitemap"
                          style={{ marginRight: '8px', color: '#ffffff' }}
                        ></i>
                        Unbundled Packages
                      </h4>
                    </div>
                    <div className="card-body p-4" style={{ background: '#fafafa' }}>
                      {jobDetails.children_packages.map((child, idx) => (
                        <div
                          key={idx}
                          className="p-4 mb-3 bg-white rounded-4 border shadow-sm d-flex justify-content-between align-items-center"
                          style={{ transition: 'all 0.3s ease' }}
                        >
                          <div>
                            <p
                              className="text-muted small mb-0 text-uppercase fw-bold"
                              style={{ fontSize: '1.1rem', letterSpacing: '0.5px' }}
                            >
                              Job ID
                            </p>
                            <h5
                              className="fw-bold mb-0"
                              style={{ color: '#007679', fontSize: '1.2rem' }}
                            >
                              {child.job_id}
                            </h5>
                          </div>
                          <div className="text-end">
                            <span
                              className="badge p-3 rounded-3"
                              style={{
                                background: 'linear-gradient(135deg, #007679 0%, #01a8af 100%)',
                                fontSize: '1rem',
                                fontWeight: '700',
                                color: 'white',
                                minWidth: '100px',
                                textAlign: 'center'
                              }}
                            >
                              {child.truck?.size || 'N/A'}
                            </span>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {/* Premium Action Buttons - Synchronized with Operator Dashboard Style */}
                <div className="text-center mt-5 mb-5 pb-5">
                  <div className="d-flex flex-wrap gap-4 justify-content-center">
                    <button
                      onClick={() => props.history.goBack()}
                      className="back-btn-operator"
                      style={{
                        background: '#007679',
                        color: 'white',
                        borderRadius: '12px',
                        padding: '1rem 3.5rem',
                        fontSize: '1.25rem',
                        fontWeight: '700',
                        boxShadow: '0 8px 20px rgba(0,118,121,0.3)',
                        border: 'none',
                        cursor: 'pointer',
                        transition: 'all 0.2s',
                      }}
                      onMouseEnter={(e) => (e.currentTarget.style.transform = 'translateY(-2px)')}
                      onMouseLeave={(e) => (e.currentTarget.style.transform = 'translateY(0)')}
                    >
                      <i className="fa fa-arrow-left me-2"></i>Back
                    </button>
                    {showUpdateJob && (
                      <button
                        onClick={() =>
                          props.history.push('/client/job/create-service-request', {
                            ...jobDetails,
                          })
                        }
                        className="update-job-btn-operator"
                        style={{
                          background: 'linear-gradient(135deg, #28a745 0%, #218838 100%)',
                          color: 'white',
                          borderRadius: '12px',
                          padding: '1rem 3.5rem',
                          fontSize: '1.25rem',
                          fontWeight: '700',
                          boxShadow: '0 8px 20px rgba(40,167,69,0.3)',
                          border: 'none',
                          cursor: 'pointer',
                          transition: 'all 0.2s',
                        }}
                        onMouseEnter={(e) => (e.currentTarget.style.transform = 'translateY(-2px)')}
                        onMouseLeave={(e) => (e.currentTarget.style.transform = 'translateY(0)')}
                      >
                        <i className="fa fa-refresh me-2"></i>Update Job
                      </button>
                    )}
                    {showDeleteJob && (
                      <button
                        onClick={handleDeleteJob}
                        className="delete-job-btn-operator"
                        style={{
                          background: '#dc3545',
                          color: 'white',
                          borderRadius: '12px',
                          padding: '1rem 3.5rem',
                          fontSize: '1.25rem',
                          fontWeight: '700',
                          boxShadow: '0 8px 20px rgba(220,53,69,0.3)',
                          border: 'none',
                          cursor: 'pointer',
                          transition: 'all 0.2s',
                        }}
                        onMouseEnter={(e) => (e.currentTarget.style.transform = 'translateY(-2px)')}
                        onMouseLeave={(e) => (e.currentTarget.style.transform = 'translateY(0)')}
                      >
                        <i className="fa fa-trash-o me-2"></i>Delete Job
                      </button>
                    )}
                    {showOpenDispute && (
                      <button
                        onClick={toggleDisputeModal}
                        className="btn btn-lg"
                        style={{
                          background: 'linear-gradient(135deg, #f6ad55 0%, #ed8936 100%)',
                          color: 'white',
                          borderRadius: '12px',
                          padding: '1rem 3.5rem',
                          fontSize: '1.25rem',
                          fontWeight: '700',
                          boxShadow: '0 8px 20px rgba(237,137,54,0.3)',
                          border: 'none',
                          cursor: 'pointer',
                          transition: 'all 0.2s',
                        }}
                        onMouseEnter={(e) => (e.currentTarget.style.transform = 'translateY(-2px)')}
                        onMouseLeave={(e) => (e.currentTarget.style.transform = 'translateY(0)')}
                      >
                        <i className="fa fa-gavel me-2"></i>
                        {jobDetails.insurance_purchashed_on
                          ? 'Request Indemnity'
                          : 'Open Dispute'}
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {rejectedJob && (
        <Chat
          name={chatName}
          chatbox={chatbox}
          user={user}
          chatToggle={chatToggle}
          chatlist={chatlist?.length > 0 ? chatlist : []}
          value={msg}
          handleTextChange={handleTextChange}
          handleOnChange={handleOnChange}
          sendButton={sendButton}
          unreadMsgsCount={unreadCount}
        />
      )}
      {disputeModal && (
        <DisputeModal
          disputeModal={disputeModal}
          toggleDisputeModal={toggleDisputeModal}
          jobDetails={jobDetails}
          container="client-page"
          refreshData={getJobDetails}
        />
      )}
    </>
  );
};

export default RejectedJobDetails;
